import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import FormCad from '../../../../components/auth/diarias/form_cad'


function CadastrarDiariasScreen() {

    return (
        <Fragment>
            <Head titulo="Cadastrar diária concedida aos servidores do Município de Macuco" />
            <HeaderLogged />
            <Container>
               <FormCad />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default CadastrarDiariasScreen;